import { gql } from '@biletiniz/apollo';

export const ALL_FLIGHT_OFFERS_QUERY = gql`
  query flightSearch(
    $flightSearchFilter: FlightSearchFilterInput
    $flightOfferFilter: FlightOfferFilterInput
    $session: String
    $renewSession: Boolean
    $page: Int
    $pageSize: Int
  ) {
    flightSearch(
      session: $session
      renewSession: $renewSession
      filter: $flightSearchFilter
      flightOfferFilter: $flightOfferFilter
      page: $page
      pageSize: $pageSize
    ) {
      session
      sessionTTL
      flightOffersViewerMap
      metadata {
        directionsMetadata {
          departureMinDate
          departureMaxDate
          arrivalMinDate
          arrivalMaxDate
          elapsedMinTime
          elapsedMaxTime
        }
        airlines {
          code
          name
        }
        stopsNumber
        flightNumber
        transitAirports {
          code
          name
        }
      }
      pagination {
        totalCount
        hasMore
        currentPage
        pageSize
        totalPages
      }
      flightOffers(filter: $flightOfferFilter) {
        id
        providerType
        providerContext
        isDirectionLevel
        isReservable
        defaultPackage
        remarks
        raw
        isDomestic
        price {
          passengerFares {
            code
            quantity
            basePrice
            taxesPrice
            totalPrice
            serviceFeesPrice
          }
          currency
          basePrice
          serviceFeesPrice
          taxesPrice
          totalPrice
        }
        packages {
          packageClass
          packageCode
          packageTitle
          prices {
            passengerFares {
              code
              quantity
              basePrice
              taxesPrice
              totalPrice
              serviceFeesPrice
            }
            packagePrice
            passengerQuantity
            passengerType
            currency
          }
          rules {
            sharedRules {
              text
              status
            }
            passengerRules {
              passengerType
              checkedBaggage {
                quantity
                pieces
                unit
              }
              carryOnBaggage {
                quantity
                pieces
                unit
              }
            }
          }
        }
        directions {
          providerContext
          elapsedTime
          defaultPackage
          price {
            passengerFares {
              code
              quantity
              basePrice
              taxesPrice
              totalPrice
              serviceFeesPrice
            }
            currency
            basePrice
            taxesPrice
            totalPrice
            serviceFeesPrice
          }
          packages {
            packageClass
            packageCode
            packageTitle
            prices {
              passengerFares {
                code
                quantity
                basePrice
                taxesPrice
                totalPrice
                serviceFeesPrice
              }
              packagePrice
              passengerQuantity
              passengerType
              currency
            }
            rules {
              sharedRules {
                text
                status
              }
              passengerRules {
                passengerType
                checkedBaggage {
                  quantity
                  pieces
                  unit
                }
                carryOnBaggage {
                  quantity
                  pieces
                  unit
                }
              }
            }
          }
          segments {
            elapsedTime
            flightNumber
            baggageUnit
            baggageQuantity
            cabinClass {
              code
              name
            }
            operatingAirline {
              code
              name
              logoUrl
            }
            airplane {
              code
              name
            }
            departureAirport {
              code
              name
            }
            arrivalAirport {
              code
              name
            }

            departureAt
            arrivalAt
          }
        }
      }
    }
  }
`;
